import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';
var COMPONENT = 'search-page';

/**
 * This experience should be started inside product codebases.
 */
export var searchPageLoadUFOExperience = new UFOExperience('load', {
  type: ExperienceTypes.Load,
  performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
  platform: {
    component: COMPONENT
  }
});
export var searchResultsLoadUFOExperience = new UFOExperience('search-results-load', {
  type: ExperienceTypes.Experience,
  performanceType: ExperiencePerformanceTypes.InlineResult,
  platform: {
    component: COMPONENT
  },
  timings: [{
    key: 'request',
    startMark: 'request_start',
    endMark: 'request_end'
  }, {
    key: 'render',
    startMark: 'render_start',
    endMark: 'render_end'
  }]
});